import { useAuthenticationContext } from "../../../../contexts/UserContext";
import packageJson from "../../../../../package.json";

export function Footer() {
    const { user } = useAuthenticationContext();
    return (
        <footer
            className={
                "bg-secondary-gray-dark text-sx text-system-white h-footer px-[62px] flex justify-between items-center"
            }
        >
            <span>© Færdselsstyrelsen 2024</span>
            <span title={`API version ${user?.backendVersion}`}>
                Version {packageJson.version}
            </span>
        </footer>
    );
}
